(function () {
  var guides = document.querySelectorAll("[data-size-guide]");

  guides.forEach(function (guide) {
    var currentUnit = "in";
    var toggle = guide.querySelector("[data-unit-toggle]");
    var unitButtons = guide.querySelectorAll("[data-unit-button]");
    var values = guide.querySelectorAll("[data-inches]");

    function formatInches(raw) {
      return raw
        .split(",")
        .map(function (value) {
          return value.trim() + "\"";
        })
        .join(" x ");
    }

    function formatCm(raw) {
      return raw
        .split(",")
        .map(function (value) {
          var cm = Number(value.trim()) * 2.54;
          return Math.round(cm) + " cm";
        })
        .join(" x ");
    }

    function setUnit(unit) {
      currentUnit = unit;
      guide.setAttribute("data-unit", unit);

      values.forEach(function (item) {
        var raw = item.getAttribute("data-inches");
        item.textContent = unit === "cm" ? formatCm(raw) : formatInches(raw);
      });

      unitButtons.forEach(function (button) {
        button.classList.toggle("is-active", button.getAttribute("data-unit-button") === unit);
      });
    }

    if (toggle) {
      toggle.addEventListener("click", function () {
        setUnit(currentUnit === "in" ? "cm" : "in");
      });
    }

    unitButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setUnit(button.getAttribute("data-unit-button"));
      });
    });

    setUnit("in");
  });
})();
